<template>
  <div class="product-detail">
    <swiper v-if="bannerList.length" ref="refBanner" class="banner" :options="swiperOption">
      <swiper-slide v-for="(item, index) in bannerList" :key="item.id">
        <van-image class="banner-img" @click="bannerPreview(index)" :src="item.FullSizeImageUrl" alt=""/>
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
    <div class="product-info">
      <div class="info-info">
        <div class="name-line">
          <p class="name">{{productData.Name}}</p>
          <a href="javascript:;" class="btn-common small btn-cart" @click="handleBooking(productData)">
            <img class="icon" src="../assets/icons/icon_plus.png" alt="">
            加入意向单
          </a>
        </div>
        <div class="price-line desc-box">
          <p>{{productData.applyTo}}</p>
          <p v-show="productData.termCondition">{{productData.termCondition}}</p>
        </div>
        <div class="price-line" v-show="$store.state.bindTicket.bookingId">
          <p><span>{{priceDiscountedCalc}}</span><span class="price-unit">美元</span>
            <i class="old-price" v-show="priceCalc && priceDiscountedCalc !== priceCalc">{{priceCalc}}美元</i>
          </p>
          <p v-show="productData.priceCondition">[ {{productData.priceCondition}} ]</p>
        </div>
        <div class="label-box" :class="{spec: !productData.promotionImage && productData.refImgUrl}">
          <div class="label" v-if="productData.promotionImage">
            <img class="label-img" :src="productData.promotionImage" />
          </div>
          <div class="sub-btn" v-if="productData.refImgName && productData.refImgUrl" @click="refImgPreviewShow = true">
            <img class="icon" src="../assets/icons/icon_warn.png" alt="">
            <span>{{productData.refImgName}}</span>
          </div>
        </div>
      </div>
      <div class="desc-detail" v-html="productData.MetaDescription"></div>
      <div class="desc-detail" v-html="productData.FullDescription"></div>
      <!-- 注意事项、条款细则 -->
      <div class="rule-title">条款细则</div>
      <product-rules :productData="productData" />
    </div>
    <div class="product-recommend" v-show="recommendList.length">
      <div class="recommend-title">其他推荐产品</div>
      <product-list :list="recommendList" />
    </div>
    <!-- 预定弹框 -->
    <dialog-booking :visible.sync="bookingShow" :goodsInfo="currentProduct" />
    <!-- banner预览 -->
    <van-image-preview
      v-model="bannerPreviewShow"
      :start-position="bannerPreviewStart"
      :images="bannerImgs"
      :close-icon="require('../assets/icons/icon_close2.png')"
      closeable
      close-on-popstate
      :show-index="false"
      show-indicators
      class-name="custom-image-preview"
    />
    <!-- 参考菜单预览 -->
    <van-image-preview
      v-model="refImgPreviewShow"
      :images="[productData.refImgUrl]"
      :close-icon="require('../assets/icons/icon_close2.png')"
      closeable
      close-on-popstate
      :show-index="false"
      class-name="custom-image-preview"
    />
  </div>
</template>

<script>
import ProductRules from './booking/ProductRules'
import ProductList from './booking/ProductList'
import DialogBooking from './DialogBooking'
import api from '@/api'
import { showLoading, hideLoading, showAlert } from '@/utils/tools'
import pick from 'lodash/pick'
import { checkOrderState } from '@/plugins/common'
import { mapState } from 'vuex'

export default {
  name: 'PageProductDetail',

  components: {
    ProductRules,
    ProductList,
    DialogBooking
  },

  props: {
    id: String
  },

  data () {
    return {
      swiperOption: {
        autoplay: {
          delay: 2000,
          disableOnInteraction: false
        },
        pagination: {
          el: '.swiper-pagination'
        }
      },
      productData: {},
      recommendList: [],
      bannerList: [],
      bookingShow: false,
      currentProduct: {},
      bannerPreviewShow: false,
      bannerPreviewStart: 0,
      refImgPreviewShow: false
    }
  },

  watch: {
    id (val) {
      this.getData()
    }
  },

  computed: {
    ...mapState(['bindTicket']),
    priceDiscountedCalc () {
      if (this.productData.ProductPrice != null) {
        // console.log(this.productData)
        const calcResult = this.productData.ProductPrice.Price
        return calcResult ? calcResult.slice(0, calcResult.length - 2) : ''
      } else {
        return null
      }
    },
    priceCalc () {
      if (this.productData.ProductPrice != null) {
        const calcResult = this.productData.ProductPrice.OldPrice
        return calcResult ? calcResult.slice(0, calcResult.length - 2) : ''
      } else {
        return null
      }
    },
    bannerImgs () {
      return this.bannerList.map(x => x.FullSizeImageUrl)
    }
  },

  mounted () {
    this.getData()
  },

  methods: {
    handleBooking (current) {
      checkOrderState(checkResult => {
        if (checkResult) {
          if (checkResult !== 'cancel') showAlert(checkResult)
        } else {
          this.currentProduct = {
            ...pick(current, ['Id', 'Name']),
            mobileBanner: current.DefaultPictureModel.ImageUrl
          }
          this.bookingShow = true
        }
      })
    },
    async getData () {
      showLoading()
      const { errCode, errMsg, data } = await api.getProductDetail(this.id)
      hideLoading()
      if (errCode === 0) {
        const { PictureModels, ...productData } = data
        this.productData = productData
        this.getRecommendData()
        // this.recommendList = recommdationViewModel && recommdationViewModel.products && recommdationViewModel.products.length ? recommdationViewModel.products : []
        this.bannerList = PictureModels || []
        // window.gio('page.set', 'Product_DetailProduct', productData.name)
      } else {
        showAlert(errMsg || '页面数据获取失败，请稍后重试')
      }
    },
    async getRecommendData () {
      showLoading()
      const { errCode, errMsg, data } = await api.getRecommend(this.id)
      if (errCode === 0) {
        this.recommendList = data && data.rows && data.rows.length ? data.rows : []
      } else {
        window.console.log(errMsg || '页面数据获取失败，请稍后重试')
      }
      hideLoading()
    },
    bannerPreview (index) {
      this.bannerPreviewStart = index
      this.bannerPreviewShow = true
    }
  }
}
</script>

<style lang="less" scoped>
.banner {
  height: 750px;
  .swiper-pagination ::v-deep .swiper-pagination-bullet {
    width: 16px;
    height: 5px;
    margin: 0 3px;
    border-radius: 2px;
    background-color: #dedede;
    &.swiper-pagination-bullet-active {
      width: 46px;
      .btn-linear-gradient;
    }
  }
}
.product-info {
  padding: 0 50px;
  background-color: #fff;
  .info-info {
    padding: 24px 0 18px;
    border-bottom: 1Px solid #eaeaea;
    .name-line {
      display: flex;
      justify-content: space-between;
      .name {
        flex: none;
        width: 390px;
        font-size: 30px;
        color: #333;
        line-height: 40px;
        font-weight: bold;
      }
      .btn-cart {
        width: 202px;
        height: 52px;
        margin: 0;
        font-size: 24px;
        .icon {
          width: 14px;
          margin-right: 10px;
        }
      }
    }
    .price-line {
      display: flex;
      align-items: flex-end;
      justify-content: space-between;
      margin-top: 16px;
      font-size: 20px;
      color: #999;
      &.desc-box {
        align-items: flex-start;
        p {
          flex: none;
          &:first-child {
            max-width: 50%;
          }
          &:last-child {
            max-width: 45%;
          }
        }
      }
      span {
        margin-right: 3px;
        font-size: 36px;
        font-weight: bold;
        color: @second-color;
      }
      .price-unit {
        font-size: 20px;
        font-weight: normal;
        color: @main-gray4;
        padding-left: 8px;
      }
      .old-price {
        font-style: normal;
        text-decoration: line-through;
      }
    }
    .label-box {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-top: 18px;
      &.spec {
        padding-top: 16px;
        justify-content: flex-end;
      }
      .label {
        .label-img {
          display: block;
          height: 30px;
          margin-right: 6px;
        }
      }
      .sub-btn {
        display: flex;
        align-items: center;
        font-size: 20px;
        color: #1174b8;
        .icon {
          width: 21px;
          height: 21px;
          margin-right: 8px;
        }
        span {
          text-decoration: underline;
        }
      }
    }
  }
  .desc-detail {
    padding: 32px 0;
    font-size: 24px;
    color: #333;
    line-height: 38px;
  }
}
.product-recommend {
  padding: 40px 50px 50px;
  .recommend-title {
    position: relative;
    height: 68px;
    margin-bottom: 30px;
    font-size: 30px;
    color: #333;
    text-align: center;
    line-height: 68px;
    &::before,
    &::after {
      content: '';
      position: absolute;
      top: 50%;
      z-index: 1;
      width: 220px;
      height: 4px;
      margin-top: -2px;
      background-color: @second-color;
    }
    &::before {
      left: 0;
    }
    &::after {
      right: 0;
    }
  }
}
.rule-title {
  position: relative;
  height: 68px;
  flex: none;
  font-size: 30px;
  color: #333;
  line-height: 68px;
  font-weight: bold;
  text-align: center;
  margin-bottom: 40px;
  &::before,
  &::after {
    content: '';
    position: absolute;
    top: 50%;
    z-index: 1;
    width: 250px;
    height: 4px;
    margin-top: -2px;
    background-color: @second-color;
  }
  &::before {
    left: 0;
  }
  &::after {
    right: 0;
  }
}
</style>
